import { NavLink } from "react-router-dom";

const ICONS: Record<string, string> = {
  "/": "M11 8h14M11 13h14M11 18h9",
  "/terms": "M11 6h10a3 3 0 0 1 3 3v11H14a3 3 0 0 1-3-3zM14 20a3 3 0 0 1-3-3",
  "/following": "M13 18v-5a5 5 0 0 1 10 0v5l1.5 2h-13zM16.5 22h3",
  "/you": "M14.5 9a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0M11.5 21a6.5 6.5 0 0 1 13 0",
};
const TABS = [
  ["/", "Today"],
  ["/terms", "Terms"],
  ["/following", "Following"],
  ["/you", "You"],
] as const;

export function TabBar() {
  return (
    <div className="tabs">
      <nav aria-label="Main">
        {TABS.map(([to, label]) => (
          <NavLink key={to} to={to} end={to === "/"}>
            <svg viewBox="0 0 36 26" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d={ICONS[to]} />
            </svg>
            {label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
